<template>
  <div class="copyToClipboard ml-2">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          @click="copyValue"
          :color="`${showCopied && 'success'} ${showError && 'error'}`"
          :class="`${showCopied && 'success'} ${showError && 'error'}`"
          x-small
          icon
        >
          <v-icon v-if="!showCopied && !showError" x-small>
            mdi-content-copy
          </v-icon>
          <v-icon v-else color="white" x-small>
            {{ showCopied && 'mdi-check' }}
            {{ showError && 'mdi-close' }}
          </v-icon>
        </v-btn>
      </template>
      <span class="caption">
        {{ $t('clickToCopy') }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CopyToClipboard',

  props: {
    value: {
      type: String,
      required: true,
    },
  },

  methods: {
    copyValue() {
      navigator.clipboard.writeText(this.value)
        .then(
          () => (this.showCopied = true),
          () => (this.showError = true)
        )
        .finally(() => {
          setTimeout(() => {
            this.showCopied = false
            this.showCopied = false
          }, 1000)
        })
    }
  },

  data() {
    return {
      showCopied: false,
      showError: false
    }
  }
}
</script>
